import * as types from '../mutation-types'
import * as constants from '../../mixins/constants'
const { sortBy, findIndex } = require('@/plugins/lodash')
import { serviceTypes } from '@/store/api/order'
import { getCookie, setAsLocalizedValue, getItemStorage } from '@/plugins/util'
import {
  CURRENCY_SYMBOL,
  COOKIE_NAME__PICKUP_LOCATION,
  COOKIE_NAME__SELECTED_SERVICE_ID,
  COOKIE_NAME__TOKEN,
  LOCAL_STORAGE_KEY__USER,
  DELIVERY_TYPE
  // COOKIE_NAME__SELECTED_TRUCK_SERVICE_ID
} from '@/mixins/constants'

const state = {
  service_types: [],
  loading: false,
  error: null,
  delivery_type: [],
  base_services: []
}

// getters
const getters = {
  serviceTypes: (state) => state.service_types, // old field
  serviceTypesTruck: (state) =>
    state.service_types.filter((e) => e.delivery_type === DELIVERY_TYPE.TRUCK),
  loadingServiceTypes: (state) => state.loading,
  unableToLoadServiceTypes: (state) => state.error,
  baseServices: (state) => state.base_services,
  services: (state, rootState) => {
    let allServices = state.service_types
    if (rootState.kaProfile && rootState.kaProfile.pinned_services) {
      rootState.kaProfile.pinned_services.forEach((s) => {
        const foundIndex = state.service_types.findIndex((st) => {
          return st._id === s._id
        })
        if (foundIndex === -1) {
          s.enable = true
          allServices.push(s)
        }
      })
    }

    let enabledServices = []
    let parentIds = []
    const estimatedFees = rootState.estimatedFeeAllServices || []
    allServices.forEach((s) => {
      if (s.parent_id && parentIds.indexOf(s.parent_id) == -1) {
        parentIds.push(s.parent_id)
      }

      if (s.enable && parentIds.indexOf(s._id) == -1) {
        enabledServices.push(s)
      }

      let userProfile

      if (!rootState.userProfile) {
        userProfile = getItemStorage(LOCAL_STORAGE_KEY__USER)
      } else {
        userProfile = rootState.userProfile
      }

      if (s.enable === false) {
        if (userProfile && userProfile.partner) {
          if (rootState.partnerProfile && rootState.partnerProfile.services && s.partner === true) {
            const existInListService = rootState.partnerProfile.services.find(
              (service) => service === s._id
            )

            if (existInListService) {
              enabledServices.push(s)
            }
          }
          if (userProfile && userProfile.extra_services) {
            const existInListExtraServiceUser = userProfile.extra_services.find(
              (service) => service === s._id
            )
            if (existInListExtraServiceUser) {
              enabledServices.push(s)
            }
          }
        } else {
          if (userProfile && userProfile.extra_services) {
            const exist = userProfile.extra_services.find((service) => service === s._id)
            if (exist) {
              enabledServices.push(s)
            }
          }
        }
      }

      if (estimatedFees.length > 0) {
        const foundIndex = estimatedFees.findIndex((ef) => {
          return ef._id === s._id
        })
        if (foundIndex > -1) {
          s.estimated_fee = estimatedFees[foundIndex]
          s.estimated_fee.valid = s.estimated_fee.total_price >= 0
          s.estimated_fee.currency_symbol = CURRENCY_SYMBOL[s.estimated_fee.currency]

          // Case: SAMEDAY service have booking time over opening_hours
          // if (s.estimated_fee.booking_time_error) {
          //   s.estimated_fee.valid = false
          //   s.unavailabe = true
          //
          //   if (s.opening_hours) {
          //     const { from, to } = getOpeningHours(s.opening_hours)
          //     if (from && to) {
          //       s.availabeFrom = from
          //       s.availabeTo = to
          //     }
          //   }
          // }
        } else {
          delete s.estimated_fee
        }
      }
    })

    setAsLocalizedValue(enabledServices, { getters: rootState })
    return sortBy(enabledServices, 'order')
  }
}

// actions
const actions = {
  getServiceTypes({ commit, dispatch, rootState }) {
    commit(types.GET_SERVICE_TYPES, { rootState, dispatch })
  },
  getServiceTypesTruck({ commit, dispatch, rootState }) {
    commit(types.GET_SERVICE_TYPES_TRUCK, { rootState, dispatch })
  },
  setServiceTypes({ commit }, data) {
    commit(types.SET_SERVICE_TYPES, { data: data })
  },
  setLoadingServiceTypes({ commit }, data) {
    commit(types.LOADING_SERVICE_TYPES, data)
  },

  setDeliveryType({ commit }, data) {
    commit(types.SET_DELIVERY_TYPES, data)
  }
}

// mutations
const mutations = {
  [types.GET_SERVICE_TYPES](state, { rootState, dispatch }) {
    state.loading = true
    let location
    const userProfile = rootState.user.profile

    const orderFormPath = rootState.orderForm.path
    if (orderFormPath[0] && orderFormPath[0].lat && orderFormPath[0].lng) {
      location = {
        lat: orderFormPath[0].lat,
        lng: orderFormPath[0].lng
      }
    } else {
      const cookieStr = getCookie(COOKIE_NAME__PICKUP_LOCATION)
      const cookieLocation = cookieStr && JSON.parse(cookieStr)
      if (cookieLocation && cookieLocation.lat && cookieLocation.lng) {
        location = cookieLocation
        location = {
          lat: cookieLocation.lat,
          lng: cookieLocation.lng
        }
      }
    }

    if (rootState.enableHomepage && state.delivery_type && state.delivery_type.length !== 0) {
      location = {
        ...location,
        delivery_type: state.delivery_type
      }
    } else {
      location = {
        ...location,
        token: getCookie(COOKIE_NAME__TOKEN)
      }
    }

    if (URLSearchParams) {
      const urlParams = new URLSearchParams(window.location.search)

      const value = urlParams.get('load_service')
      if (value) location.user_mobile = userProfile._id
    }

    if (location && location.lat && location.lng) {
      state.error = null

      serviceTypes(location)
        .then((services) => {
          // limit services in case webinapp
          const servicesByFlatform = []
          state.base_services = services
          services.forEach((s) => {
            // set payment methods from service to empty, allow all methods get from api
            let payload = { ...s, payment_method: [] }

            const webInAppId = rootState.webInAppConfig && rootState.webInAppConfig.id
            if (webInAppId) {
              const enablePlatform = s.enable_platform || []
              if (enablePlatform.length === 0 || enablePlatform.indexOf(webInAppId) === -1) {
                return
              }
            }

            // set limit max cod due to user profile/ webinapp configs
            if (userProfile.verified && userProfile.max_cod) {
              payload = {
                ...payload,
                max_cod_per_stop_point: userProfile.max_cod || s.max_cod,
                max_cod: s.max_cod
              }
            } else if (rootState.webInAppConfig && rootState.webInAppConfig.id) {
              // set limit max cod value by config of webinapp mode
              const userVerified = (userProfile && userProfile.verified) || false

              if (!userVerified) {
                payload = {
                  ...payload,
                  max_cod_per_stop_point: rootState.webInAppConfig.maxCod || s.max_cod,
                  max_cod: rootState.webInAppConfig.maxCod || s.max_cod
                }
              }
            } else {
              payload = {
                ...payload,
                max_cod_per_stop_point: s.max_cod,
                max_cod: s.max_cod
              }
            }

            if (rootState.webInAppConfig && rootState.webInAppConfig.paymentMethods) {
              payload = {
                ...payload,
                payment_method: rootState.webInAppConfig.paymentMethods.map((methods) => ({
                  payment: methods
                }))
              }
            }

            servicesByFlatform.push(payload)
          })

          state.service_types = servicesByFlatform
        })
        .catch((error) => {
          state.error = error
        })
        .finally(() => {
          const excludedDeliveryTypes = [
            DELIVERY_TYPE.RENTAL,
            DELIVERY_TYPE.TRUCK,
            DELIVERY_TYPE.NATIONWIDE
          ]

          let bikeServiceTypes = [...state.service_types]

          bikeServiceTypes = bikeServiceTypes.filter((s) => {
            return !excludedDeliveryTypes.includes(s.delivery_type)
          })

          if (bikeServiceTypes.length > 0) {
            state.service_types = bikeServiceTypes

            if (
              !rootState.orderForm.service._id ||
              rootState.orderForm.service.delivery_type === DELIVERY_TYPE.TRUCK ||
              rootState.orderForm.service.delivery_type === DELIVERY_TYPE.RENTAL ||
              rootState.orderForm.service.delivery_type === DELIVERY_TYPE.NATIONWIDE
            ) {
              const cookieService = getCookie(COOKIE_NAME__SELECTED_SERVICE_ID)

              const foundIndex =
                cookieService &&
                findIndex(bikeServiceTypes, (s) => {
                  return s._id === cookieService && Boolean(bikeServiceTypes)
                })
              if (typeof foundIndex === 'number' && foundIndex > -1) {
                dispatch('setOrderFormService', bikeServiceTypes[foundIndex])
              } else {
                dispatch('setOrderFormService', bikeServiceTypes[0])
              }
            } else {
              const serviceId = rootState.orderForm.service._id
              // Check selected service available for new location
              const isServiceAvaiable = bikeServiceTypes.find((s) => s._id === serviceId)

              // Selected unavailabe for new location
              if (!isServiceAvaiable && bikeServiceTypes[0]._id) {
                const splitServiceAndCityIndex = serviceId.indexOf('-')

                const selectedCity =
                  splitServiceAndCityIndex !== -1
                    ? serviceId.substr(0, splitServiceAndCityIndex)
                    : null
                const selectedService =
                  splitServiceAndCityIndex !== -1
                    ? serviceId.substr(splitServiceAndCityIndex + 1)
                    : null
                const newCity = bikeServiceTypes[0]._id.split('-')[0]

                // Update service with new city prefix
                if (selectedCity && newCity) {
                  const serviceWithNewCity = `${newCity}-${selectedService}`
                  const existed = bikeServiceTypes.find((s) => s._id === serviceWithNewCity)
                  if (existed) {
                    dispatch('setOrderFormService', existed)
                  }
                  // Get the first service_type available if not existed service with new address
                  else {
                    dispatch('setOrderFormService', bikeServiceTypes[0])
                  }
                }
              }
            }
          }

          state.loading = false
        })
    } else {
      state.loading = false
    }
  },
  [types.GET_SERVICE_TYPES_TRUCK](state, { rootState, dispatch }) {
    state.loading = true
    let location
    const userProfile = rootState.user.profile

    const orderFormPath = rootState.orderForm.path
    if (orderFormPath[0] && orderFormPath[0].lat && orderFormPath[0].lng) {
      location = {
        lat: orderFormPath[0].lat,
        lng: orderFormPath[0].lng
      }
    } else {
      const cookieStr = getCookie(COOKIE_NAME__PICKUP_LOCATION)
      const cookieLocation = cookieStr && JSON.parse(cookieStr)
      if (cookieLocation && cookieLocation.lat && cookieLocation.lng) {
        location = cookieLocation
        location = {
          lat: cookieLocation.lat,
          lng: cookieLocation.lng
        }
      }
    }

    location = {
      ...location,
      delivery_type: constants.DELIVERY_TYPE.TRUCK
    }

    if (location && location.lat && location.lng) {
      state.error = null

      serviceTypes(location)
        .then((services) => {
          // limit services in case webinapp
          const servicesByFlatform = []

          state.base_services = services

          services.forEach((s) => {
            // set payment methods from service to empty, allow all methods get from api
            let payload = { ...s, payment_method: [] }

            const webInAppId = rootState.webInAppConfig && rootState.webInAppConfig.id
            if (webInAppId) {
              const enablePlatform = s.enable_platform || []
              if (enablePlatform.length === 0 || enablePlatform.indexOf(webInAppId) === -1) {
                return
              }
            }

            // set limit max cod due to user profile/ webinapp configs
            if (userProfile.verified && userProfile.max_cod) {
              payload = {
                ...payload,
                max_cod_per_stop_point: userProfile.max_cod || s.max_cod,
                max_cod: s.max_cod
              }
            } else if (rootState.webInAppConfig && rootState.webInAppConfig.id) {
              // set limit max cod value by config of webinapp mode
              const userVerified = (userProfile && userProfile.verified) || false

              if (!userVerified) {
                payload = {
                  ...payload,
                  max_cod_per_stop_point: rootState.webInAppConfig.maxCod || s.max_cod,
                  max_cod: rootState.webInAppConfig.maxCod || s.max_cod
                }
              }
            } else {
              payload = {
                ...payload,
                max_cod_per_stop_point: s.max_cod,
                max_cod: s.max_cod
              }
            }

            if (rootState.webInAppConfig && rootState.webInAppConfig.paymentMethods) {
              payload = {
                ...payload,
                payment_method: rootState.webInAppConfig.paymentMethods.map((methods) => ({
                  payment: methods
                }))
              }
            }

            servicesByFlatform.push(payload)
          })

          state.service_types = servicesByFlatform
        })
        .catch((error) => {
          state.error = error
          state.service_types = []
        })
        .finally(() => {
          if (state.service_types.length > 0) {
            if (
              !rootState.orderForm.service._id ||
              rootState.orderForm.service.delivery_type !== DELIVERY_TYPE.TRUCK
            ) {
              // const cookieService = getCookie(COOKIE_NAME__SELECTED_TRUCK_SERVICE_ID)
              // const foundIndexServiceSaved =
              //   cookieService &&
              //   findIndex(state.service_types, (s) => {
              //     return (
              //       s._id === cookieService && ![DELIVERY_TYPE.RENTAL].includes(s.delivery_type)
              //     )
              //   })
              const foundIndexServiceRecommend = findIndex(state.service_types, (s) => {
                return s.is_recommend === true
              })

              // if (typeof foundIndexServiceSaved === 'number' && foundIndexServiceSaved > -1) {
              //   dispatch('setOrderFormService', state.service_types[foundIndexServiceSaved])
              // } else
              if (
                typeof foundIndexServiceRecommend === 'number' &&
                foundIndexServiceRecommend > -1
              ) {
                dispatch('setOrderFormService', state.service_types[foundIndexServiceRecommend])
              } else {
                dispatch('setOrderFormService', state.service_types[0])
              }
            } else {
              const serviceId = rootState.orderForm.service._id
              // Check selected service available for new location
              const isServiceAvaiable = state.service_types.find((s) => s._id === serviceId)

              // Selected unavailabe for new location
              if (!isServiceAvaiable && state.service_types[0]._id) {
                const splitServiceAndCityIndex = serviceId.indexOf('-')

                const selectedCity =
                  splitServiceAndCityIndex !== -1
                    ? serviceId.substr(0, splitServiceAndCityIndex)
                    : null
                const selectedService =
                  splitServiceAndCityIndex !== -1
                    ? serviceId.substr(splitServiceAndCityIndex + 1)
                    : null
                const newCity = state.service_types[0]._id.split('-')[0]

                const foundIndexServiceRecommend = findIndex(state.service_types, (s) => {
                  return s.is_recommend === true
                })

                // Update service with new city prefix
                if (selectedCity && newCity) {
                  const serviceWithNewCity = `${newCity}-${selectedService}`
                  const existed = state.service_types.find((s) => s._id === serviceWithNewCity)
                  if (existed) {
                    dispatch('setOrderFormService', existed)
                  } else if (
                    typeof foundIndexServiceRecommend === 'number' &&
                    foundIndexServiceRecommend > -1
                  ) {
                    dispatch('setOrderFormService', state.service_types[foundIndexServiceRecommend])
                  } else {
                    dispatch('setOrderFormService', state.service_types[0])
                  }
                }
              }
            }
          }

          state.loading = false
        })
    } else {
      state.loading = false
    }
  },

  [types.SET_SERVICE_TYPES](state, { data }) {
    state.service_types = data
    state.loading = false
  },

  [types.LOADING_SERVICE_TYPES](state, data) {
    state.loading = data
  },

  [types.SET_DELIVERY_TYPES](state, data) {
    state.delivery_type = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
